import { useState } from 'react';
import { useNavigate, type HistoryState } from '@tanstack/react-router';
import { startKubicle1a } from '@/services/kubicle1a';
import { getQualityTier } from '@/hooks/useQualityTier';

/** The home screen's Kubicle 1A start: create the lesson on the picked tier, then open its chat with the kickoff. */
export function useKubicle1aStart() {
  const navigate = useNavigate();
  const [starting, setStarting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function start(title: string, script: string) {
    setError(null);
    setStarting(true);
    try {
      const { videoId, kickoff } = await startKubicle1a({ title, script, qualityTier: getQualityTier() });
      await navigate({
        to: '/chat/$conversationId/video-workspace',
        params: { conversationId: videoId },
        state: { autoSend: true, userInstructions: kickoff } as HistoryState,
      });
    } catch (err) {
      setError((err as Error).message);
      setStarting(false);
    }
  }

  return { start, starting, error };
}
